<template>
<div class="chapter">
<div class="inner_page">
<p class="h2-1"><b>Illustrations</b></p>
<p class="tocc-1"><span href="#/html/9780292749375_03_fm#a1" title="Link target outside of Sample">John Holland Jenkins, <i>Frontispiece</i></span></p>
<p class="tocc-1"><a href="#/html/9780292749375_12_htit1#a2">Republic of Texas (map)</a></p>
<p class="tocc-1"><a href="#/html/9780292749375_13_ch1#a3">Austin’s Little Colony (map)</a></p>
<p class="tocc-1"><a href="#/html/9780292749375_13_ch1#a4">Bastrop, Texas (map)</a></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a5" title="Link target outside of Sample">Indians</span></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a6" title="Link target outside of Sample">Storming of the Alamo</span></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a7" title="Link target outside of Sample">Indian horsemen</span></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a8" title="Link target outside of Sample">Santa Anna</span></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a9" title="Link target outside of Sample">Felix Huston</span></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a10" title="Link target outside of Sample">Edward Burleson</span></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a11" title="Link target outside of Sample">Ben McCulloch</span></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a12" title="Link target outside of Sample">Sam Highsmith in Santa Anna’s uniform</span></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a13" title="Link target outside of Sample">R. M. Williamson</span></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a14" title="Link target outside of Sample">Jack Hays</span></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a15" title="Link target outside of Sample">John B. Jones</span></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a16" title="Link target outside of Sample">Caddo chief</span></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a17" title="Link target outside of Sample">Placido, Chief of the Tonkawas</span></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a18" title="Link target outside of Sample">Kiowa chief</span></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a19" title="Link target outside of Sample">The Battle of Plum Creek</span></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a20" title="Link target outside of Sample">Indian war dance</span></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a21" title="Link target outside of Sample">Comanche warrior</span></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a22" title="Link target outside of Sample">Trading with the Indians</span></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a23" title="Link target outside of Sample">Austin in 1844</span></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a24" title="Link target outside of Sample">Texas Rangers, Company D, in 1887</span></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a25" title="Link target outside of Sample">Home of A. Wiley Hill in Bastrop</span></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a26" title="Link target outside of Sample">The French Embassy in Austin</span></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a27" title="Link target outside of Sample">Home of Campbell Taylor in Bastrop</span></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a28" title="Link target outside of Sample">Home of Col. Washington Jones in Bastrop</span></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a29" title="Link target outside of Sample">Home of John Holland Jenkins in Bastrop</span></p>
<p class="tocc-1"><span href="#/html/9780292749375_20_ch8#a30" title="Link target outside of Sample">John Twohig residence in San Antonio</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292749375_11_illu.vue?3d0ac6b0